module.exports = __webpack_public_path__ + "static/media/stage-product-icons-io.8b1194c5.svg";